export const initialAftercareForm = {
  currentStudent: '',
  addressEntered: '',
  cityStateZip: '',
  motivationSystem: '',
  careerInterests: '',
  noWorkHistory: false,
  workHistory: [
    {
      employer: '',
      startDate: '',
      endDate: '',
    },
    {
      employer: '',
      startDate: '',
      endDate: '',
    },
    {
      employer: '',
      startDate: '',
      endDate: '',
    },
  ],
  plansCommunityCollege: false,
  plansMilitary: false,
  plans4YearCollege: false,
  plansWorkforce: false,
  plansVocationalTraining: false,
  plansOther: false,
  plansJobCorps: false,
  plansOtherExplain: '',
  boystownEmployment: '',
  boystownAftercare: false,
  boystownIT: false,
  boystownFacilities: false,
  boystownLegal: false,
  boystownFinance: false,
  boystownMarketing: false,
  boystownHospital: false,
  boystownSecurity: false,
  boystownHR: false,
  boystownYouthCare: false,
  boystownInfoSec: false,
  acSummerLivingArrangements: '',
  acFallLivingArrangements: '',
  otherIncome: '',
  explainOtherIncome: '',
  guardiansFinancialHelp: '',
  acHealthInsurance: '',
  essay: '',
  housingServicesSignature: '',
  housingServicesDate: '',
  tradeLifeSignature: '',
  tradeLifeDate: '',
  version: 2,
};
